module.exports = __webpack_public_path__ + "static/media/builtinv2-Pitanie 2 1.4dc53f6a.png";